import {Component, Input} from '@angular/core';
import {PixRecipientResponse} from '@gatewee/services';
import {PixEmvDecoded} from '@gatewee/utils/validators/pix-emv.validator';
import {
  formatRecipientAccount,
  formatRecipientAgency,
} from '../withdrawal-pix-recipient.utils';

@Component({
  selector: 'app-withdrawal-step-review',
  templateUrl: './withdrawal-step-review.component.html',
  standalone: false,
})
export class WithdrawalStepReviewComponent {
  @Input() pixRecipientResponse: PixRecipientResponse | null = null;
  @Input() resolvedRecipientName = '';
  @Input() emvDecoded: PixEmvDecoded | null = null;
  /** Amount from the value step (used when EMV has no tag 54 or after user entry). */
  @Input() reviewAmount: number | null = null;
  @Input() description = '';

  formatAgency = formatRecipientAgency;
  formatAccount = formatRecipientAccount;

  get isEmvReview(): boolean {
    return this.emvDecoded !== null;
  }

  get reviewRecipientName(): string {
    if (this.isEmvReview) {
      return this.emvDecoded?.merchantName ?? '';
    }
    return this.resolvedRecipientName;
  }

  /** Prefer EMV tag 54; fall back to the amount captured on the value step. */
  get emvEffectiveAmount(): number | null {
    const fromEmv = this.emvDecoded?.amount;
    if (typeof fromEmv === 'number' && Number.isFinite(fromEmv)) {
      return fromEmv;
    }
    if (
      typeof this.reviewAmount === 'number' &&
      Number.isFinite(this.reviewAmount) &&
      this.reviewAmount > 0
    ) {
      return this.reviewAmount;
    }
    return null;
  }

  get hasEmvFixedAmount(): boolean {
    return this.emvEffectiveAmount !== null;
  }
}
